export default __webpack_public_path__ + "static/media/august-min.f2a0bb9a.jpg";